// ---------- le HTML construit à la main : échapper, créer un élément, une icône ----------
// Une seule version, importée partout : trois copies vivaient séparément (profile.ts, together.ts,
// home.ts), et un correctif posé sur l'une aurait laissé les deux autres ouvertes — elles
// protègent toutes des textes tapés par des joueurs (pseudos, titres de créations). Relevé en revue
// le 2026-10-16.

export function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
}

/** Un élément, sa classe, son contenu — les écrans construits à la main (l'outil de création, le
 *  panneau de partage), sans gabarit. `html` va tel quel dans innerHTML : rien de tapé par un
 *  joueur n'y passe sans escapeHtml. Une seule copie, pour la même raison qu'escapeHtml : elle
 *  vivait à l'identique dans creer.ts et sharePanel.ts (relevé à la revue du 2026-10-17). */
export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  cls?: string,
  html?: string,
): HTMLElementTagNameMap[K] {
  const e = document.createElement(tag);
  if (cls) e.className = cls;
  if (html !== undefined) e.innerHTML = html;
  return e;
}

/** Une icône du sprite (cf. la note en fin de index.html), à poser dans un innerHTML. */
export const icon = (id: string): string =>
  `<svg class="i" aria-hidden="true"><use href="#${id}"></use></svg>`;
